<template>
  <div class="alert" :class="type">
    {{ message }}
    <button type="button" class="close" @click="hide()" data-dismiss="alert" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
export default {
  name: "Modal",
  props: ["message", "type"],
  methods: {
    hide() {
      this.$emit("close");
    }
  }
};
</script>
